import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <Sidebar />
      <div className="dashboard">
        <Navbar />
        <div className="container">
        
        <div className="dashboard-header">
          <h1>Dashboard</h1>
          <p>Manage your YouTube videos from here</p>
          
          <div className="dashboard-actions">
            <button 
              className="btn btn-primary" 
              onClick={() => navigate('/upload')}
            >
              Upload New Video
            </button>
            <button 
              className="btn btn-secondary" 
              onClick={() => navigate('/videos')}
            >
              View All Videos
            </button>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Dashboard;
